const RetryInstallment = ({
    item,
    retryDate,
    minRetryDate,
    setRetryDate,
    onBack,
    onSubmit,
}) => {
    const formatDate = (date) =>
        date ? new Date(date).toLocaleDateString("en-GB") : "N/A";

    return (
        <div className="max-w-5xl mx-auto bg-white border rounded-lg shadow p-4 sm:p-5 overflow-x-auto">
            <button
                onClick={onBack}
                className="mb-4 px-3 py-2 text-white text-sm bg-blue-500 rounded hover:bg-blue-600"
            >
                ← Back to Installments
            </button>

            <h3 className="text-xl font-semibold text-center mb-4">
                Retry Installment
            </h3>

            <div className="space-y-2 text-sm min-w-[320px]">
                <div className="flex flex-col sm:flex-row sm:justify-between gap-1 border-b pb-2">
                    <span className="text-gray-500">Installment ID</span>
                    <span className="font-medium break-all">
                        {item?.id}
                    </span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-1 border-b pb-2">
                    <span className="text-gray-500">Description</span>
                    <span className="font-medium break-words sm:text-right">
                        {item?.client_meta?.description || "N/A"}
                    </span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-1 border-b pb-2">
                    <span className="text-gray-500">Amount</span>
                    <span className="font-semibold">
                        ₹ {Number(item?.payer?.amount?.value).toLocaleString("en-IN")}
                    </span>
                </div>

                <div className="border-b pb-2">
                    <span className="text-gray-500 block">Payer</span>
                    <div className="font-medium break-words">
                        {item?.payer?.account?.name || "N/A"}
                    </div>
                    <div className="text-xs text-gray-500">
                        {item?.payer?.account?.mobile_number}
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 border-b pb-2">
                    <div>
                        <span className="text-gray-500 block">Due Date</span>
                        <span className="font-medium">
                            {formatDate(item?.due_date)}
                        </span>
                    </div>

                    <div>
                        <span className="text-gray-500 block">Scheduled Date</span>
                        <span className="font-medium">
                            {formatDate(item?.schedule_date)}
                        </span>
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-1 border-b pb-2">
                    <span className="text-gray-500">Current Status</span>
                    <span className="font-medium break-all">
                        {item?.state}
                    </span>
                </div>

                <div>
                    <label className="text-gray-500 block mb-1">
                        Select Retry Date
                    </label>
                    <input
                        type="date"
                        value={retryDate}
                        min={minRetryDate}
                        onChange={(e) => setRetryDate(e.target.value)}
                        className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-500"
                    />
                    <p className="text-xs text-gray-400 mt-1">
                        Retry date must be at least 2 days after the due date
                    </p>
                </div>
            </div>

            <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 mt-6">
                <button
                    onClick={onBack}
                    className="w-full sm:w-auto px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                >
                    Cancel
                </button>

                <button
                    onClick={onSubmit}
                    className="w-full sm:w-auto px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                >
                    Confirm Retry
                </button>
            </div>
        </div>
    );
};

export default RetryInstallment;
